/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarSize } from '@atlaskit/editor-common/types';
import { FormattingTextDropdownMenu } from './Toolbar/dropdown-menu';
import { useClearIcon } from './Toolbar/hooks/clear-formatting-icon';
import { useFormattingIcons } from './Toolbar/hooks/formatting-icons';
import { ToolbarType } from './Toolbar/types';
var FloatingToolbarSettings = {
  disabled: false,
  isReducedSpacing: true,
  shouldUseResponsiveToolbar: false,
  toolbarSize: ToolbarSize.XXXS,
  hasMoreButton: false,
  moreButtonLabel: '',
  toolbarType: ToolbarType.FLOATING
};
var FloatingToolbarTextFormat = function FloatingToolbarTextFormat(_ref) {
  var api = _ref.api,
    editorAnalyticsAPI = _ref.editorAnalyticsAPI,
    editorView = _ref.editorView,
    intl = _ref.intl;
  var _useSharedPluginState = useSharedPluginState(api, ['textFormatting']),
    textFormattingState = _useSharedPluginState.textFormattingState;
  var defaultIcons = useFormattingIcons({
    schema: editorView.state.schema,
    intl: intl,
    isToolbarDisabled: FloatingToolbarSettings.disabled,
    editorAnalyticsAPI: editorAnalyticsAPI,
    textFormattingState: textFormattingState,
    toolbarType: FloatingToolbarSettings.toolbarType
  });
  var clearIcon = useClearIcon({
    textFormattingState: textFormattingState,
    intl: intl,
    editorAnalyticsAPI: editorAnalyticsAPI,
    toolbarType: FloatingToolbarSettings.toolbarType
  });
  var items = useMemo(function () {
    if (!clearIcon) {
      return [{
        items: defaultIcons
      }];
    }
    return [{
      items: defaultIcons
    }, {
      items: [clearIcon]
    }];
  }, [clearIcon, defaultIcons]);
  return jsx(FormattingTextDropdownMenu, {
    editorView: editorView,
    items: items,
    isReducedSpacing: FloatingToolbarSettings.isReducedSpacing,
    moreButtonLabel: FloatingToolbarSettings.moreButtonLabel,
    hasFormattingActive: FloatingToolbarSettings.hasMoreButton,
    hasMoreButton: FloatingToolbarSettings.hasMoreButton,
    intl: intl,
    toolbarType: FloatingToolbarSettings.toolbarType
  });
};
export var FloatingToolbarTextFormalWithIntl = injectIntl(FloatingToolbarTextFormat);